import { CHANNELS } from "../../shared/channels";
import { TaskEntry } from "../../shared/types";
import { call } from "../bridge";
import { byId } from "../dom";
import { t } from "../i18n";
import { flash } from "../tweens";
import { CHIX_INBOX } from "../../shared/task_status";
import { renderBoardPicker } from "./task_boards";

// sticky note overlay for adding and editing chix tasks

let editingId = "";
let board = CHIX_INBOX;
let boardFrom = CHIX_INBOX;

const nameInput = () => byId<HTMLInputElement>("task-editor-name");
const descriptionInput = () => byId<HTMLTextAreaElement>("task-editor-description");

function cleanError(error: unknown): string {
  return String(error).replace(/^.*Error: /, "");
}

// a new task starts on `startBoard`, usually the board the tuner is on
export function openTaskEditor(task: TaskEntry | null, startBoard = CHIX_INBOX): void {
  editingId = task?.id ?? "";
  board = boardFrom = task ? task.boardId || CHIX_INBOX : startBoard;
  renderBoardPicker(byId("task-editor-boards"), board, (key) => (board = key));
  byId("task-editor-title").textContent = task ? t("edit chix task") : t("new chix task");
  nameInput().value = task?.title ?? "";
  descriptionInput().value = task?.description ?? "";
  byId("task-editor-status").textContent = "";
  byId("task-editor").hidden = false;
  nameInput().focus();
}

function closeEditor(): void {
  byId("task-editor").hidden = true;
}

async function save(): Promise<void> {
  const changes: { name: string; description: string; board?: string } = { name: nameInput().value.trim(), description: descriptionInput().value.trim() };
  if (!editingId || board !== boardFrom) changes.board = board;
  if (!changes.name) {
    flash(nameInput());
    return;
  }
  byId("task-editor-status").textContent = t("saving...");
  try {
    if (editingId) await call(CHANNELS.chixEdit, editingId, changes);
    else await call(CHANNELS.chixAdd, changes);
    closeEditor();
  } catch (error) {
    byId("task-editor-status").textContent = cleanError(error);
  }
}

export async function completeTask(task: TaskEntry): Promise<void> {
  if (!confirm(t("mark \"{title}\" as done?", { title: task.title }))) return;
  try {
    await call(CHANNELS.chixComplete, task.id);
  } catch (error) {
    alert(cleanError(error));
  }
}

export function setupTaskEditor(): void {
  byId("task-editor-save").addEventListener("click", save);
  byId("task-editor-cancel").addEventListener("click", closeEditor);
  nameInput().addEventListener("keydown", (event) => {
    if (event.key === "Enter") save();
  });
}
